import type { SiteListClient } from '@wix/site-list-client';
import type { WriteDebugLogFn } from '@wix/cli-debug-log';
import { readAppConfig } from '../files/app.config.js';
import { SiteState } from './site-state.js';

export async function resolveConfiguredSite({
  projectFolder,
  siteListClient: { getSite },
  siteId,
  writeDebugLog,
}: {
  projectFolder: string;
  siteListClient: SiteListClient;
  siteId?: string;
  writeDebugLog?: WriteDebugLogFn;
}) {
  const resolvedSiteId = !siteId
    ? (await readAppConfig(projectFolder, writeDebugLog))?.siteId
    : siteId;

  if (!resolvedSiteId) {
    return SiteState.NotConfigured();
  }

  const site = await getSite(resolvedSiteId);

  if (!site) {
    return SiteState.NotFound({ id: resolvedSiteId });
  }

  return SiteState.Resolved({ site });
}
